import { List, ListItem, Navbar, Page } from "framework7-react";

import { CategoryChip } from "@/components/CategoryChip";
import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";
import { useUserCategories } from "@/hooks/useUserCategories";

export const CategoryListPage = createPage("CategoryListPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps, isPageReady } = usePageReady(pageName);
  const userCategories = useUserCategories({ skip: !isPageReady });

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>カテゴリ設定</NavTitle>
        <NavRightEmpty />
      </Navbar>
      <List
        dividersIos
        inset
        mediaList
        strong
      >
        {userCategories.map((userCategory) => (
          <ListItem
            key={userCategory.id}
            chevronCenter
            link={`/settings/app/categories/${userCategory.categoryKey}/`}
          >
            <div slot="content-start">
              <CategoryChip categoryKey={userCategory.categoryKey} />
            </div>
          </ListItem>
        ))}
      </List>
    </Page>
  );
}
